import { forwardRef } from 'react';
import { IStyled } from '../../styles/types';
import SvgIcon from './SvgIcon';

interface IProps extends IStyled {
  isSortAsc: boolean;
  isActive?: boolean;
}

const TableSortIcon = forwardRef<SVGSVGElement, IProps>(
  ({ isSortAsc, isActive, className }, ref) => (
    <SvgIcon
      ref={ref}
      className={className}
      name={isSortAsc ? 'table-sort-asc' : 'table-sort-desc'}
      width={12}
      height={12}
      isActive={isActive}
      isHoverable={true}
      customFill="currentColor"
    />
  ),
);

export default TableSortIcon;
